import React from 'react';
import './App.css';
import { Navigation } from 'design-system-idm';
import Logo from './assests/logo.png'
import Home from './screens/parkshome';
import About from './screens/parksabout';
import Activities from './screens/parksactivities';
import Locations from './screens/parkslocation';
import Involve from './screens/parksinvolve';
import { BrowserRouter as Router, Switch, Route, NavLink } from "react-router-dom";


function App() {
  return (
    <div className="App">
      <Router>
      <Navigation
      logo={<NavLink to="/"> <img src={Logo} alt="logo"></img></NavLink>}
      BCKGDcolor="#04944F">
        <NavLink to="/about">About Us</NavLink>
        <NavLink to="/activities">Activities</NavLink>
        <NavLink to="/involve">Get Involved</NavLink>
        <NavLink to="/location">Services</NavLink>
      </Navigation>
        <Switch>	
          <Route exact path="/">
						<Home />
					</Route>				
          <Route path="/about">
						<About />
					</Route>
          <Route path="/activities">
						<Activities />
					</Route>
          <Route path="/involve">
						<Involve />
					</Route>
          <Route path="/location">
						<Locations />
					</Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
